import { esPublicYolMu, HATA_YOLLARI } from "./rotaMuafiyet";

function uygulamaIciMi(adres) {
  if (!adres) return false;
  const yol = adres.split("?")[0];
  return !esPublicYolMu(yol, adres) && !HATA_YOLLARI.includes(yol);
}

function hedefYolu(hedef) {
  if (!hedef) return null;
  return typeof hedef === "string" ? hedef.split("?")[0] : hedef.path || null;
}

// Başlık ikonu ve yol izi (SB7) bunu kullanır — ana sayfa yedeği buraya girmez (GBH).
export function ustYolu(route) {
  const kayit = [...route.matched].reverse().find((r) => r.meta && r.meta.ust);
  if (!kayit) return null;
  return typeof kayit.meta.ust === "function" ? kayit.meta.ust(route) : kayit.meta.ust;
}

// GBH (K2): geri düğmesinin hedefi. Sıra: uygulama içi geçmiş ('geri') → meta.ust → yedek →
// ana sayfa. Hedef mevcut yolun kendisiyse null (düğme gizlenir).
// window.history.state reaktif değil: çağıran computed route'u okuduğu için route değişince
// yeniden hesaplanır; vue-router geçmiş kaydını route güncellenmeden önce yazar.
export function geriHedefi(route, anaSayfa = null, yedek = null) {
  const onceki = window.history.state ? window.history.state.back : null;
  if (onceki && uygulamaIciMi(onceki)) return "geri";
  const hedef = ustYolu(route) || yedek || anaSayfa;
  if (!hedef || hedefYolu(hedef) === route.path) return null;
  return hedef;
}

export function geriGit(router, route, yedek = null, anaSayfa = null) {
  const hedef = geriHedefi(route, anaSayfa, yedek);
  if (hedef === "geri") return router.back();
  if (hedef) return router.replace(hedef);
}
